// Polyfill of es6-promise for some browsers (Like IE 11)
// https://github.com/vuejs-templates/webpack/issues/474
// https://github.com/stefanpenner/es6-promise
require('es6-promise/auto')
// Polyfill for babel IE10+
// Important: GTM includes Hotjar, which has it's own version of babel-polyfill.js
// The version of babel-polyfill we're running will throw an exception if it's already
// included in the page. This means we need to do a check to see if _babelPolyfill is in
// the page before we require it
if (!global || !global._babelPolyfill) {
  require('babel-polyfill')
}
import 'promise-polyfill/src/polyfill'
// Polyfill of ie-array-find for some browsers (Like IE 11)
// github.com/abdalla/ie-array-find-polyfill
import 'ie-array-find-polyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import cart from './modules/cart'
import user from './modules/user'
import order from './modules/order'
import globalstate from './modules/global'
import createLogger from '../../plugins/logger'
import VeeValidate from 'vee-validate'

Vue.use(Vuex)
Vue.use(VeeValidate)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    cart,
    order,
    user,
    globalstate
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./vue/checkout/store/index.js